<template lang="html">
    <div v-if="params && params.isActive">
        <ModalDefault
            size="m"
            :with-content="true"
            @close="params.isActive = false;"
            :theme="true"
            :fix-height="false"
            :fix-width="false"
            :loading="loading"
        >
            <template slot="main">
                <section class="delete-brand">
                    <p class="modal-title">{{ $trad.common.disable }} {{ params.zone.name.toUpperCase() }}</p>
                    <p v-html-safe="$t('zonerole.deleteZone', { zone: params.zone.name.toUpperCase() })"></p>
                    <div class="row d-flex justify-content-end">
                        <ClientColorButton :background-color="currentBrand.linksColor" @click="disableBrandZone();" class="mr-3">{{
                            $trad.common.disable
                        }}</ClientColorButton>
                        <ClientColorButton :inactiveColor="true" @click.prevent="params.isActive = false;">{{
                            $trad.common.cancel
                        }}</ClientColorButton>
                    </div>
                </section>
            </template>
        </ModalDefault>
    </div>
</template>

<script lang="js">
import ModalDefault from "@/components/ui/ModalDefault";
import {mapState} from "vuex";
import historyService from "@/services/history";
import {OBJECT_TYPE, SHORT_DESCRIPTION} from "@/components/history/constants";
import httpService from "@/components/service";

export default {
    name: 'disable-zone',
    components: {ModalDefault},
    props: [
        'params'
    ],
    data() {
        return {
            loading: false
        }
    },
    methods: {
        disableBrandZone () {
            this.isLoading = true;
            httpService.delete("/admin/zones/" + this.params.zone.id)
                .then(() => {
                    this.dialogSuccess(SHORT_DESCRIPTION.ZONE_DISABLED);
                    this.isLoading = false;
                    this.params.isActive = false;
                    this.$emit("success");
                })
                .catch(() => {
                    this.isLoading = false;
                    this.dialogError('ERROR');
                });
        }
    },
    computed: {
        ...mapState("currentUser", ["currentBrand"]),
    }
}
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// DisableZone.vue?78b839d4